import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c3814c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-distribution" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = {
  key: 0,
  class: "distribution-content"
}
const _hoisted_4 = {
  ref: "chartRef",
  class: "pie-chart"
}
const _hoisted_5 = { class: "legend-list" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "legend-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t('positionDistribution.title')), 1),
    (_ctx.positions.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, null, 512),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "legend-item"
              }, [
                _createElementVNode("span", {
                  class: "legend-color",
                  style: _normalizeStyle({ backgroundColor: _ctx.colors[index] })
                }, null, 4),
                _createElementVNode("span", {
                  class: "legend-name",
                  title: item.name
                }, _toDisplayString(item.name), 9, _hoisted_6),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatValue(item.percentage)), 1)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock(_component_Nodata, {
          key: 1,
          mode: "vertical",
          customdesc: _ctx.t('positionDistribution.noData')
        }, null, 8, ["customdesc"]))
  ]))
}